import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { getRegion } from '../../../../utils/Region';
//-----------------------------------------------------------------------------------------------
import './style.scss';
import { getTranslation, jsonParseTraslation } from 'utils/getTranslation';

export const NotFoundSearchResults = ({
  value,
  doubleError = false,
  withoutEnclosure = false,
}) => {
  const [textContent, setTextContent] = useState(null);
  const { notFoundResults } = useSelector(state => state.search.searchResults);
  const texts = useSelector(state => state.metadata.translations);
  const parseTranslation = jsonParseTraslation(texts);
  const titleLabel = getTranslation(
    'withoutResults_alert_title_label',
    parseTranslation,
  );
  const descriptionLabel = getTranslation(
    'withoutResults_alert_description_label',
    parseTranslation,
  );
  const popularNotFoundLabel = getTranslation(
    'popularSearches_withoutResults_alert_title_label',
    parseTranslation,
  );

  const { type, status } = notFoundResults;

  useEffect(
    () => {
      switch (type) {
        case 'searchResults':
          setTextContent(
            <p className="not-found-search-results__text">
              <strong className='not-found-search-results__label'>{`${titleLabel} ${value}  `}</strong>
              <span>{descriptionLabel}</span>
            </p>,
          );
          break;
        case 'failureService':
          setTextContent(
            <p className="not-found-search-results__text-failure">
              {popularNotFoundLabel}
            </p>,
          );
          break;
        default:
          setTextContent(null);
          break;
      }
    },
    [type],
  );

  if (status === false) return;
  
  return (
    <div
      className={`not-found-search-results ${(withoutEnclosure || doubleError) &&
        'withoutEnclosure'}`}
    >
      <p className="not-found-search-results__text">
        {doubleError && (
          <p className="not-found-search-results__text-failure">
            {popularNotFoundLabel}
          </p>
        )}

        {!doubleError ? textContent : ''}
      </p>
    </div>
  );
};

NotFoundSearchResults.propTypes = {
  value: PropTypes.string.isRequired,
};
